import { AfterViewInit, Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { PageComponent, PageHeaderComponent } from '@softapps/core/pages';
import {
  backNavigation,
  MenuItem,
  menuItems,
  subtitle,
  title,
} from '@softline/application';
import { DynamicModule } from '@softline/dynamic';
import { TranslatePipe, translator } from '@softline/ui-core';
import { SOFTLINE_CONST_LAGER_ABC_ANALYSIS_CONFIG_KEY } from '../../abc-analysis.shared';
import { Configuration } from '../../models/configuration';
import { AbcAnalysisService } from '../../services/abc-analysis.service';

@Component({
  selector: 'soft-abc-analysis-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DynamicModule, PageHeaderComponent, PageComponent, TranslatePipe],
})
export class ConfigurationComponent implements AfterViewInit {
  private readonly abcAnalysisService = inject(AbcAnalysisService);
  private readonly router = inject(Router);
  private readonly t = translator();

  readonly configuration = signal<Configuration | null>(null);

  constructor() {
    title(this.t('#ABC_ANALYSIS.APP_TITLE'));
    subtitle(this.t('#ABC_ANALYSIS.CONFIGURATION.SUBTITLE'));
    backNavigation('/abc-analysis/storage-selection');
    menuItems(
      () =>
        [
          {
            name: 'storage-selection',
            type: 'route',
            outlet: 'nav',
            icon: 'fa-regular fa-warehouse',
            routerLink: ['abc-analysis', 'storage-selection'],
            title: '#ABC_ANALYSIS.STORAGE_SELECTION.MENU_ITEM',
          },
          {
            name: 'configuration',
            type: 'route',
            outlet: 'nav',
            icon: 'fa-regular fa-gear',
            routerLink: ['abc-analysis', 'configuration'],
            title: '#ABC_ANALYSIS.CONFIGURATION.MENU_ITEM',
          },
          {
            name: 'submit',
            title: 'Speichern',
            outlet: 'responsive',
            class: 'soft-button primary',
            type: 'execute',
            icon: 'fa-regular fa-save',
            canExecute: this.configuration() !== null,
            execute: () => this.onSubmit(),
          },
        ] as MenuItem[]
    );
  }

  ngAfterViewInit() {
    const configuration = this.abcAnalysisService.loadConfiguration(
      SOFTLINE_CONST_LAGER_ABC_ANALYSIS_CONFIG_KEY
    );
    this.configuration.set(configuration);
  }

  readonly onSubmit = () => {
    const configuration = this.configuration();
    if (!configuration) return;
    this.abcAnalysisService.saveConfiguration(
      SOFTLINE_CONST_LAGER_ABC_ANALYSIS_CONFIG_KEY,
      configuration
    );
    this.router.navigate(['/abc-analysis/storage-selection']);
  };
}
